/*
 * Toggles the `xo-quantity__button--blur` class on cart line-item minus buttons
 * so the minus button is disabled whenever the quantity is 1.
 *
 * The quantity web component (xo-webcomponents) updates the input value
 * reactively but never touches this class, so we mirror it here. The actual
 * disabled styling lives in custom.css. Scoped to cart line items only.
 */
(function () {
  'use strict';

  var ITEM_SELECTOR = '.xo-cart-item, .xo-cart-mini-item, .xo-cart-table';
  var BLUR_CLASS = 'xo-quantity__button--blur';

  function syncQuantity(quantityEl) {
    if (!quantityEl) return;
    var input = quantityEl.querySelector('input');
    var minus = quantityEl.querySelector('.xo-quantity__button--minus');
    if (!input || !minus) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = 1;
    minus.classList.toggle(BLUR_CLASS, value <= 1);
  }

  function syncAll() {
    var els = document.querySelectorAll(ITEM_SELECTOR + ' xo-cart-quantity');
    Array.prototype.forEach.call(els, syncQuantity);
  }

  // +/- clicks update the value asynchronously, so re-check a couple of times.
  function syncSoon(quantityEl) {
    syncQuantity(quantityEl);
    setTimeout(function () { syncQuantity(quantityEl); }, 0);
    setTimeout(function () { syncQuantity(quantityEl); }, 200);
  }

  function inCart(el) {
    return el && el.closest && el.closest(ITEM_SELECTOR);
  }

  // Manual typing in the input.
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches('xo-cart-quantity input') && inCart(input)) {
      syncQuantity(input.closest('xo-cart-quantity'));
    }
  });

  // Plus / minus button clicks.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('xo-cart-quantity-minus, xo-cart-quantity-plus');
    if (btn && inCart(btn)) {
      syncSoon(btn.closest('xo-cart-quantity'));
    }
  });

  // Re-sync when the cart re-renders or the drawer opens.
  // We only mutate class attributes, so a childList observer won't loop.
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  });

  function start() {
    syncAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
